// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"acc349e5","70":"7e0c91dd","125":"176104ae","127":"a586d242","498":"fa851ae8"}[chunkId] + ".chunk.js";
};